import {useEffect} from "react";

/**
 * Event listener to close Dialog on Escape and save Input on Enter
 * @param {boolean} isOpen - Whether the dialog is open
 * @param {function} callback - Function to call on Escape key press
 */
export default function useKeyToClose( isOpen, callback ) {

  useEffect( () => {
    const handleKeyDown = ( event ) => {
      if ( event.key === 'Escape' ) {
        callback();
        event.stopImmediatePropagation();
      }
    };

    if ( isOpen ) {
      document.addEventListener( 'keydown', handleKeyDown );
    }

    return () => {
      document.removeEventListener( 'keydown', handleKeyDown );
    };
  }, [isOpen, callback] );
}
